'use client';

import { classNames } from '@/shared/lib/classNames/classNames';

interface MainContainerProps {
  children?: React.ReactNode | React.ReactNode[];
  className?: string;
}

export const MainContainer: React.FC<MainContainerProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={classNames({
        cls: 'mx-auto max-w-[1208px] px-5 sm:px-11 xl:px-5',
        additional: [className],
      })}
    >
      {children}
    </div>
  );
};
